import { StartupPage } from './StartupPage';

export default StartupPage;
